export class EnumApiCommon {
    constructor() {
        /**
         * @dec 上传视频/图片
         * @method post
         * @params
         */
        this.common_file_watermark = {
            url: '/api/bpportal/pcsd-bp-customer-comsvr/v1/file/watermark?marked=false',
            method: 'post',
        };
        /**
         * @dec 上传图片
         * @method post
         * @params
         */
        this.common_file_image = {
            url: '/api/bpportal/pcsd-bp-customer-comsvr/v1/file/uploadPic',
            method: 'post',
        };
        /**
         * @dec 上传视频/图片
         * @method post
         * @params
         */
        this.common_file_upload = {
            url: '/internal/file/system/upload',
            method: 'post',
            headers: {
                'x-app-id': 'BPP-test',
                'x-fos-code': 'd296fc44-ffd2-238c-e4ca-2ca06cbd74a6',
            },
        };
        /**
         * @dec 公司性质
         * @method get
         * @params
         */
        this.common_companyNature = {
            url: '/api/bpportal/pcsd-bp-common/commondictionaryitems/companyNature/-1',
            method: 'get',
        };
        /**
         * @dec 公司类型
         * @method get
         * @params
         */
        this.common_companyType = {
            url: '/api/bpportal/pcsd-bp-common/commondictionaryitems/companyType/-1',
            method: 'get',
        };
        /**
         * @dec 联想品牌产品经营范围
         * @method get
         * @params
         */
        this.common_businessRange = {
            url: '/api/bpportal/pcsd-bp-common/commondictionaryitems/BusinessRange/-1',
            method: 'get',
        };
        /**
         * @dec 其他主要品牌
         * @method get
         * @params
         */
        this.common_saleProduction = {
            url: '/api/bpportal/pcsd-bp-common/commondictionaryitems/SaleProduction/-1',
            method: 'get',
        };
        /**
         * @dec 经营方式
         * @method get
         * @params
         */
        this.common_businessMode = {
            url: '/api/bpportal/pcsd-bp-common/commondictionaryitems/BusinessMode/-1',
            method: 'get',
        };
        /**
         * @dec 选择重点客户单选
         * @method get
         * @params
         */
        this.common_industryType = {
            url: '/api/bpportal/pcsd-bp-common/commondictionaryitems/IndustryType/-1',
            method: 'get',
        };
        /**
         * @dec 选择重点客户多选
         * @method get
         * @params
         */
        this.common_industryTypeList = {
            url: '/api/bpportal/pcsd-bp-common/commondictionaryitems/IndustryType/',
            method: 'get',
        };
        /**
         * @dec 企业覆盖地区
         * @method get
         * @params
         */
        this.common_commonsingleprovinces = {
            url: '/api/bpportal/pcsd-bp-common/commondictionaryitems/commonsingleprovinces/getallcommonsingleprovincelist',
            method: 'get',
        };
        //
    }
}
